import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const SecuritiesAccountForm = React.lazy(() =>
    import('../SecuritiesAccountForm')
);
const securitiesAccountFormRoutesRegistry = [
    {
        path: PAGE_URL.SECURITIES_ACCOUNT_FORM_PAGE,
        element: <SecuritiesAccountForm />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default securitiesAccountFormRoutesRegistry;
